import { RouteObject } from "react-router-dom";
import IvrIntegrationLanding from "./components/landing/landing";

export interface IvrIntegrationRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: IvrIntegrationRoute[];
}
export const ixIvrIntegrationRoutes: IvrIntegrationRoute[] = [
  {
    path: "/integration-hub/ivr-integration",
    element: <IvrIntegrationLanding />,
  },
];
